module.exports = __webpack_public_path__ + "media/images/convenios/con_ing_agronomia-3756604beba2b27d305fc89091619918.jpg";